import { render, staticRenderFns } from "./NoveltiesList.vue?vue&type=template&id=3545d4d3&lang=pug&"
import script from "./NoveltiesList.vue?vue&type=script&lang=js&"
export * from "./NoveltiesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports